var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCartoon = function SvgCartoon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 105 104"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#cartoon_svg__a)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 72,
    height: 72,
    x: 16.5,
    y: 12,
    fill: "#fff",
    rx: 8,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#1F4970",
    clipPath: "url(#cartoon_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M52.5 37.875a3.938 3.938 0 1 0 0-7.875 3.938 3.938 0 0 0 0 7.875M65.227 39H39.773a1.898 1.898 0 0 0 0 3.797h7.164c.486 0 1.055.217 1.377 1.055.376.972.191 2.85-.04 4.305l-.304 1.719a.03.03 0 0 1-.009.025L45.53 63.739a1.93 1.93 0 0 0 1.557 2.232 1.9 1.9 0 0 0 2.21-1.568l1.68-9.619s.54-2.284 1.524-2.284c1 0 1.529 2.285 1.529 2.285l1.68 9.627a1.914 1.914 0 0 0 3.472.775 1.92 1.92 0 0 0 .299-1.45l-2.434-13.839v-.013l-.007-.011-.305-1.72c-.232-1.454-.416-3.332-.04-4.305.32-.835.908-1.054 1.356-1.054h7.177a1.899 1.899 0 0 0 0-3.797z"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "cartoon_svg__b"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M34.5 30h36v36h-36z"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "cartoon_svg__a",
    width: 104,
    height: 104,
    x: 0.5,
    y: 0,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.745833 0 0 0 0 0.745833 0 0 0 0 0.745833 0 0 0 0.64 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5293_46891"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_5293_46891",
    result: "shape"
  })))));
};
export default SvgCartoon;